export function displayWithMaxDigit(value: number): string {
  return value?.toLocaleString(undefined, {
    maximumFractionDigits: 1,
  });
}

export function truncateToDecimals(num: number, decimals: number) {
  const numStr = num.toString();
  const decimalPos = numStr.indexOf('.');
  if (decimalPos === -1) {
    // No decimal point, return as is with fixed decimals
    return num.toFixed(decimals);
  }
  // Calculate the position to truncate the string
  const truncatePos = decimalPos + decimals + 1;
  const truncatedStr = numStr.substring(0, truncatePos);
  return Number(truncatedStr);
}

export const formatNumberWithDecimals = (
  value: number,
  decimalPoints = 0
) => {
  const truncatedValue = truncateToDecimals(value, decimalPoints);
  return truncatedValue.toLocaleString(undefined, {
    maximumFractionDigits: decimalPoints,
    minimumFractionDigits: decimalPoints,
  });
};
